import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoginCallbackComponent } from 'axis-components/components/okta/components/login-callback.component';
import { CommonErrorsModule } from 'axis-components/components/common-errors/common-errors.module';
import { LogoutComponent } from 'axis-components/components/okta/components/logout.component';
import { CardModule } from 'axis-components/components/card/card.module';
import { DisableIfUnauthorizedDirective } from 'axis-components/components/okta/directives/disable-if-unauthorized.directive';
import { HideIfUnauthorizedDirective } from 'axis-components/components/okta/directives/hide-if-unauthorized.directive';
@NgModule({
  imports: [
    CommonModule,
    CardModule,
    CommonErrorsModule
  ],
  declarations: [
    LoginCallbackComponent,
    LogoutComponent,
    DisableIfUnauthorizedDirective,
    HideIfUnauthorizedDirective
  ],
  exports: [
    LoginCallbackComponent,
    LogoutComponent,
    DisableIfUnauthorizedDirective,
    HideIfUnauthorizedDirective
  ]
})
export class AxisOktaModule { }
